module.exports = __webpack_public_path__ + "img/電気回路_6_2.596cc9c6.png";